// extracted by mini-css-extract-plugin
module.exports = {"ldsRing":"style-module--lds-ring--1pUcm"};